<script setup>
import { ref, onMounted, watchEffect, watch } from 'vue'
import { useStore } from 'vuex'
import { Calendar, Icon, ActionSheet, TreeSelect, Cascader, Popup } from 'vant'
import dayjs from 'dayjs'
import { getBindModuleInfo } from '@/api/person'
import { getSchoolListByUser } from '@/api/admin'
import DataStatistics from './components/DataStatistics.vue'
import FillingRecord from './components/FillingRecord.vue'

const store = useStore()

// 当前选中的tab
const currentType = ref('dataStatistics')
// tab切换
const handleTypeChange = (type) => {
  if (type !== currentType.value) {
    currentType.value = type
  }
}

// 是否显示时间选择器
const showTimePicker = ref(false)
// 时间选择
const handleTimeBtnClick = () => {
  showTimePicker.value = true
}
// 显示的时间范围
const date = ref('')
const formDate = ref({
  start: '',
  end: '',
})
const formatDate = (date) => `${date.getMonth() + 1}/${date.getDate()}`
const onTimeConfirm = (values) => {
  let [start, end] = values
  end = new Date(end.getTime() + 24 * 60 * 60 * 1000 - 1000)
  formDate.value.start = dayjs(start).format('YYYY-MM-DD HH:mm:ss')
  formDate.value.end = dayjs(end).format('YYYY-MM-DD HH:mm:ss')

  showTimePicker.value = false
  date.value = `${formatDate(start)} - ${formatDate(end)}`

  console.log('formDate', formDate)
}

// 表格类型选择
const showChartTypePicker = ref(false)
// 表格类型
const chartType = ref(0)
const chartActions = [
  {
    name: '填报占比',
    value: 0,
  },
  { name: '柱状图统计', value: 1 },
]
// 表格类型选择
const handleChartTypeSelect = (data) => {
  if (data.value !== chartType.value) {
    chartType.value = data.value
  }
  showChartTypePicker.value = false
}

// 获取级联的所有的最小级
const extractInnermostIdsWithLevels = (data) => {
  let ids = {
    firstId: [],
    secondId: [],
    thirdId: [],
  }

  function findInnermostIds(nodes, level) {
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        findInnermostIds(node.children, level + 1)
      } else {
        if (level === 1) {
          ids.firstId.push(node.id)
        } else if (level === 2) {
          ids.secondId.push(node.id)
        } else if (level === 3) {
          ids.thirdId.push(node.id)
        }
        // ids[level].push(node.id)
      }
    })
  }

  findInnermostIds(data, 1)
  return {
    firstId: ids.firstId.join(','),
    secondId: ids.secondId.join(','),
    thirdId: ids.thirdId.join(','),
  }
}

// 级联年级选择
const showTreeDataPicker = ref(false)
const handleTreeDataSelect = (data) => {
  console.log(data)
  showTreeDataPicker.value = false
}

// 级联数据
const treeData = ref([])
// 显示的范围
const formTree = ref({
  firstId: '',
  secondId: '',
  thirdId: '',
})
// 所有的权限
const allTreeData = ref({
  firstId: '',
  secondId: '',
  thirdId: '',
})
// 获取个人可以查看级联的列表
const fetchTreeList = async () => {
  const res = await getSchoolListByUser({
    typeId: store.state.moduleInfo?.typeId,
    token: store.getters.getToken,
  })

  if (res.ok) {
    try {
      const data = JSON.parse(res.data.manageInfo)

      treeData.value = transformTreeData(data)

      formTree.value = { ...extractInnermostIdsWithLevels(treeData.value) }
      allTreeData.value = { ...formTree.value }
      treeData.value = [
        {
          name: '全部',
          id: -1,
        },
        ...treeData.value,
      ]
    } catch (error) {}
  }
}

// 转换树形数据,去掉children为空数组的情况
const transformTreeData = (data) => {
  const result = []
  data.map((item) => {
    const obj = {
      name: item.name,
      id: item.id,
      children: item.children ? transformTreeData(item.children) : [],
    }
    if (obj.children.length === 0) {
      delete obj.children
    }
    result.push(obj)
  })
  return result
}

// 级联选择显示
const showCascader = ref(false)
const cascadeIds = ref([])
const cascadeName = ref('选择学校年级')
// 级联第几级
const cascaderLevel = ref(1)
// 级联选择确定
const onCascaderFinish = ({ selectedOptions, tabIndex }) => {
  cascadeName.value = selectedOptions.map((option) => option.name).join('/')
  cascadeIds.value = [selectedOptions[selectedOptions.length - 1]?.id]
  cascaderLevel.value = tabIndex + 1

  if (tabIndex === 0) {
    if (selectedOptions[tabIndex].id === -1) {
      formTree.value = { ...allTreeData.value }

      showCascader.value = false
      return
    }

    formTree.value.firstId =
      selectedOptions[tabIndex].id === -1 ? '' : selectedOptions[tabIndex].id
    formTree.value.secondId = ''
    formTree.value.thirdId = ''
  }
  if (tabIndex === 1) {
    formTree.value.firstId = ''
    formTree.value.secondId = selectedOptions[tabIndex].id
    formTree.value.thirdId = ''
  }
  if (tabIndex === 2) {
    formTree.value.firstId = ''
    formTree.value.secondId = ''
    formTree.value.thirdId = selectedOptions[tabIndex].id
  }

  showCascader.value = false
}

// 获取模板信息
const useFetchModuleInfo = async () => {
  if (!store.getters.getQuesInfo.moduleId) {
    return
  }
  const fetchData = async () => {
    const res = await getBindModuleInfo({
      moduleId: store.getters.getQuesInfo.moduleId,
      orgId: store.getters.getOrgId,
    })
    if (res.ok) {
      store.commit('setModuleInfo', {
        data: res.data[0],
      })
    }
  }

  await fetchData()
}

watchEffect(async () => {
  if (store.getters.getModuleInfo?.typeId) {
    fetchTreeList()
  } else {
    await useFetchModuleInfo()
    fetchTreeList()
  }
})
</script>
<template>
  <div class="admin-page">
    <!-- tab选项 -->
    <div class="type-switch-wrap">
      <div
        @click="handleTypeChange('dataStatistics')"
        class="type-item"
        :class="{ active: currentType === 'dataStatistics' }"
      >
        <img class="type-item-icon" src="@/assets/img/admin/excel.png" alt="" />
        <span>数据统计</span>
      </div>
      <div
        @click="handleTypeChange('fillingRecord')"
        class="type-item"
        :class="{ active: currentType === 'fillingRecord' }"
      >
        <img
          class="type-item-icon"
          src="@/assets/img/admin/record.png"
          alt=""
        />
        <span> 填报记录</span>
      </div>
    </div>
    <!-- 搜索框 -->
    <div class="search-wrap">
      <div @click="handleTimeBtnClick" class="search-item">
        {{ date || '选择时间'
        }}<Icon class="search-item-icon" name="arrow-down" />
      </div>
      <div
        v-show="currentType === 'dataStatistics'"
        @click="showChartTypePicker = true"
        class="search-item"
      >
        {{ chartType === 0 ? '填报占比' : '柱状图统计'
        }}<Icon class="search-item-icon" name="arrow-down" />
      </div>
      <div @click="showCascader = true" class="search-item van-ellipsis">
        {{ cascadeName }} <Icon class="search-item-icon" name="arrow-down" />
      </div>
    </div>

    <!-- 数据统计 -->
    <DataStatistics
      v-if="currentType === 'dataStatistics'"
      :formTree="formTree"
      :chartType="chartType"
      :formDate="formDate"
    />
    <!-- 填报记录 -->
    <FillingRecord
      v-else="currentType === 'fillingRecord'"
      :formTree="formTree"
      :formDate="formDate"
    />
    <!-- 时间选择器 -->
    <Calendar
      v-model:show="showTimePicker"
      type="range"
      color="#087EFB"
      :min-date="new Date(2010, 0, 1)"
      :max-date="new Date()"
      @confirm="onTimeConfirm"
    />
    <!-- 表格类型选择 -->
    <ActionSheet
      v-model:show="showChartTypePicker"
      :actions="chartActions"
      @select="handleChartTypeSelect"
    />
    <!-- 年级级联选择 -->
    <Popup v-model:show="showCascader" round position="bottom">
      <Cascader
        title="请选择"
        active-color="#1d7dff"
        :field-names="{
          value: 'id',
          text: 'name',
        }"
        :options="treeData"
        @finish="onCascaderFinish"
        @close="showCascader = false"
      />
    </Popup>
  </div>
</template>
<style scoped lang="scss">
/* vatn覆盖样式*/
:root {
  --van-tree-select-item-active-color: #087efb;
}

.admin-page {
  background-color: #f1f3f5;
  min-height: 100vh;
}
.type-switch-wrap {
  display: flex;
  justify-content: space-between;
  padding: 38px 25px;
  background-color: #ffffff;

  .type-item {
    box-sizing: border-box;
    width: 341px;
    height: 112px;
    padding: 0 13px;
    display: flex;
    align-items: center;
    font-size: 28px;
    color: #1e322a;
    box-shadow: 0 0.4vw 1.733vw rgba(0, 114, 89, 0.1803921568627451);
    background-color: #e7faf3;

    .type-item-icon {
      margin-right: 26px;
      width: 50px;
      height: 50px;
    }

    &.active {
      color: #1f2c5f;
      border: 1px solid #4fc186;

      &:last-of-type {
        border-color: #3db8fe;
      }
    }

    &:last-of-type {
      background-color: #e6f5ff;
    }
  }
}

.search-wrap {
  padding: 0 25px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  gap: 6px;
  background-color: #ffffff;

  .search-item {
    position: relative;
    box-sizing: border-box;
    width: 341px;
    height: 58px;
    padding: 0 10px;
    line-height: 58px;
    background-color: rgba($color: #999999, $alpha: 0.1);
    border-radius: 5px;
    font-size: 24px;
    color: #555555;

    .search-item-icon {
      position: absolute;
      display: flex;
      align-items: center;
      font-size: 24px;
      right: 11px;
      top: 0;
      bottom: 0;
      margin: auto;
      color: rgba($color: #333, $alpha: 0.5);
    }
  }
}
</style>
